
































import {
  BackgroundJobActionTypes,
  BackgroundJobStatusTypes,
  ClassifiedBackgroundJob
} from '~/models/background-jobs/types'
import { format } from '~/utils/date'
import { capitalizeString } from '~/utils/string'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { ciClock } from '~/icons/source/regular/clock'

export default defineComponent({
  props: {
    jobs: {
      type: Array as PropType<ClassifiedBackgroundJob[]>,
      required: true
    },
    jobsStatus: {
      type: String,
      required: true
    }
  },
  setup() {
    return {
      ciClock
    }
  },
  computed: {
    successText() {
      return capitalizeString(
        this.$tc('succeeded action | succeeded actions', this.jobs.length)
      )
    },
    failedText() {
      return capitalizeString(
        this.$tc('failed action | failed actions', this.jobs.length)
      )
    }
  },
  methods: {
    getJobTypeTranslation(type: string) {
      if (type === BackgroundJobActionTypes.MASS_TOUCH) {
        return this.$t('mass update')
      }
      if (type === BackgroundJobActionTypes.PRICE_CHANGE) {
        return this.$t('mass price change')
      }
      return this.$t('action')
    },
    getStatusTranslation(status: string) {
      if (status === BackgroundJobStatusTypes.TERMINATED) {
        return this.$t('terminated::status')
      } else if (status === BackgroundJobStatusTypes.COMPLETED) {
        if (this.jobsStatus === 'failed') {
          return this.$t('failed::status')
        }
        return this.$t('completed::status')
      } else if (status === BackgroundJobStatusTypes.PENDING) {
        return this.$t('pending::status')
      } else if (status === BackgroundJobStatusTypes.RUNNING) {
        return this.$t('running::status')
      }

      return '...'
    },
    lastUpdate(job) {
      return format(job.lastUpdated)
    }
  }
})
